<template>
  <div class="onboarding-layout">
    <div class="onboarding-progress-bar">
      <div class="progress-text">Step {{ currentStep }} of {{ totalSteps }}</div>
      <v-progress-linear
        :model-value="progressValue"
        color="primary"
        height="10"
        rounded
      ></v-progress-linear>
    </div>
    <div class="onboarding-title">
      Get Started with Structure
    </div>
    <router-view />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const currentStep = computed(() => route.meta.step || 1);
const totalSteps = computed(() => route.meta.totalSteps);

const progressValue = computed(() => {
  return (currentStep.value / totalSteps.value) * 100;
});
</script>

<style scoped lang="scss">
  @import "@/assets/styles/OnboardingLayout.scss"
</style>
